import * as React from 'react';
import { NaviContext } from './NaviContext';
export function useLoadingRoute() {
    return React.useContext(NaviContext).busyRoute;
}
// This is a PureComponent so that setting state to loading
// when it is already loading won't cause a re-render
export function LoadingRoute(props) {
    return (React.createElement(NaviContext.Consumer, null, function (context) { return props.children(context.busyRoute); }));
}
//# sourceMappingURL=LoadingRoute.js.map